import { apiClient } from "./api_base";

export const fetchMeals = async (params = {}) => {
  const response = await apiClient.get('/meals', { params });
  return response;
};

export const createMeal = async (mealData) => {
  const hasFile = mealData && typeof mealData === 'object' && mealData.image_file instanceof File;
  if (hasFile) {
    const formData = new FormData();
    Object.entries(mealData).forEach(([key, value]) => {
      if (value === undefined || value === null) return;
      formData.append(key, value);
    });
    const response = await apiClient.post('/meals', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response;
  }
  const response = await apiClient.post('/meals', mealData);
  return response;
};

export const fetchMealById = async (id) => {
  const response = await apiClient.get(`/meals/${id}`);
  return response;
};

export const acknowledgeMealProductSyncNotice = async (id) => {
  const response = await apiClient.post(`/meals/${id}/ack-product-sync-notice`);
  return response;
};

export const updateMeal = async (id, mealData) => {
  const hasFile = mealData && typeof mealData === 'object' && mealData.image_file instanceof File;
  if (hasFile) {
    const formData = new FormData();
    Object.entries(mealData).forEach(([key, value]) => {
      if (value === undefined || value === null) return;
      formData.append(key, value);
    });
    formData.append('_method', 'PUT');
    const response = await apiClient.post(`/meals/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response;
  }
  const response = await apiClient.put(`/meals/${id}`, mealData);
  return response;
};

export const updateMealSalesPrice = async (id, salesPriceTotal) => {
  const response = await apiClient.put(`/meals/${id}/sales-price`, {
    sales_price_total: salesPriceTotal,
  });
  return response;
};

export const deleteMeal = async (id) => {
  const response = await apiClient.delete(`/meals/${id}`);
  return response;
};

export const addMealComponent = async (mealId, componentData) => {
  const response = await apiClient.post(`/meals/${mealId}/components`, componentData);
  return response;
};

export const updateMealComponent = async (mealId, componentId, componentData) => {
  const response = await apiClient.put(`/meals/${mealId}/components/${componentId}`, componentData);
  return response;
};

export const deleteMealComponent = async (mealId, componentId) => {
  const response = await apiClient.delete(`/meals/${mealId}/components/${componentId}`);
  return response;
};

export const reorderMealComponents = async (mealId, componentIds) => {
  const response = await apiClient.put(`/meals/${mealId}/components/reorder`, { component_ids: componentIds });
  return response;
};

export const getCountries = async () => {
  const response = await apiClient.get('/countries');
  return response;
};

export const duplicateMeal = async (mealId, mealData = {}) => {
  const response = await apiClient.post(`/meals/${mealId}/duplicate`, mealData);
  return response;
};

